// extracted by mini-css-extract-plugin
module.exports = {"dateInputClass":"styles_dateInputClass__2udRg"};